import classnames from "classnames";
import { getCulture } from "CMS/utils";
import CopyToClipboard from "components/Atoms/CopyToClipboard";
import React from "react";
import { useLoaderData } from "react-router";
import { JsonApiUrlInput } from "./components";
import { getEmbedCodeText, getEmbedUrl, getRawJsonUrl } from "./embedcodes";
import { WizardState } from "./models";
import { Wizard } from "./wizard";
import { useCurrentUser } from "common/SessionContext";

const EmbedWizardApp = () => {
  const currentUser = useCurrentUser();
  const viewModel = useLoaderData<server.viewmodel.EmbedShowsFrontModel>();

  const [state, setState] = React.useState<WizardState>({
    theme: "normal",
    culture: getCulture(currentUser.culture),
    font: "Inter",
    perPage: 8,
    upcomingShowDays: 365 * 2,
    pastShowsDays: 0,
    displayPagination: true,
    displayHeader: true,
    filterBy: "AllArtists",
    artists: [],
    productions: [],
    includeCancelled: false
  });

  const embedHeight = "800";
  const embedWidth = "100%";

  const artistIds = state.artists.map(a => a.artistId);
  const productionIds = state.productions.map(p => p.productionId);

  const embedUrl = getEmbedUrl(viewModel.friendlyId, state.displayPagination, state.displayHeader, state.culture.locale, state.font, `${state.perPage}`, artistIds, productionIds, state.theme, state.pastShowsDays, state.upcomingShowDays, state.includeCancelled);
  const jsonUrl = getRawJsonUrl(viewModel.friendlyId, state.culture.locale, `${state.perPage}`, artistIds, productionIds, state.pastShowsDays, state.upcomingShowDays, state.includeCancelled);
  const embedCodeText = getEmbedCodeText({ url: embedUrl, width: embedWidth, height: embedHeight });

  const previewClasses = classnames("s1_panel grow1", {
    large: embedWidth === "100%"
  });

  return <div className="flex" id="two-column-page-layout">
    <div className="margin-right-bigger smallright flex-column gap-bigger">
      <Wizard
        state={state}
        setState={setState}
      />
      <div className="s1_panel">
        <div className="margin-bottom">
          <div className="padding-bottom-mini s1_smaller">Embed code:</div>
          <CopyToClipboard value={embedCodeText} />
        </div>

        <div>
          <div className="padding-bottom-mini s1_smaller">API endpoint with JSON data:</div>
          <JsonApiUrlInput url={jsonUrl} />
        </div>
      </div>

      <div className="s1_panel">
        <form action="https://systemonesoftware.us13.list-manage.com/subscribe/post?u=20cb5b0b0a3bd05e1d0359ca0&amp;id=ca192042d9" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" target="_blank" noValidate>
          <div id="mc_embed_signup_scroll" className="flex-column gap">
            <div>
              <div className="margin-bottom-small"><h3>Are you a developer?</h3></div>
              <div className="s1_gray">Be informed about important changes</div>
            </div>
            <div>
              <input type="email" name="EMAIL" className="email fluid" id="mce-EMAIL" placeholder="email address" required />

              <div style={{ position: "absolute", left: "-5000px" }} aria-hidden="true">
                <input type="text" name="b_20cb5b0b0a3bd05e1d0359ca0_ca192042d9" tabIndex={-1} />
              </div>
            </div>

            <div className="flex justify-end">
              <button type="submit" name="subscribe" id="mc-embedded-subscribe" className="button-new primary">Subscribe</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <embed src={embedUrl} className={previewClasses} style={state.theme === "dark" ? { backgroundColor: "black" } : { backgroundColor: "white" }} />
  </div>
};

export default EmbedWizardApp;